module.exports = __webpack_public_path__ + "static/media/undo-disabled-icon.2661665c.svg";